
import { Vue, Component } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import { required } from "@/cms-services/consts";
@Component
export default class Home extends Vue {
  dataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 15,
    },
    className: "PromoCode",
  });

  model = {
    caption:"",
    code:"",
    discountType:1,
    diccount:"",
    startDateTime:null,
    endDateTime:null,
    allowedCount:0
  }

  fields = [
    {
      name:"caption",
      editor:"string",
      attrs:{
        label:"Заголовок"
      },
      validations:[required()],
      grid:{
        cols:6
      }
    },
    {
      name:"code",
      editor:"string",
      attrs:{
        label:"Код"
      },
      validations:[required()],
      grid:{
        cols:6
      }
    },
    {
      name:"discountType",
      editor:"enum",
      attrs:{
        label:"Тип скдики"
      },
      config:{
        type: "radio",
        getItems:"getDiscounTypes",
        valueKeyName:"id",
        labelKeyName:"caption"
      },
      validations:[required()]
    },
    {
      name:"discount",
      editor:"number",
      attrs:{
        label:"Скидка"
      },
      validations:[required()],
      grid:{
        cols:6
      }
    },
    {
      name:"allowedCount",
      editor:"number",
      attrs:{
        label:"Сколько раз может применять 1 пользователь"
      },
      validations:[required()],
      grid:{
        cols:6
      }
    },
    {
      name:"startDateTime",
      editor:"date",
      config: {
        
      attrs: {
          outlined: true,
          label: "Начало",
          appendIcon: "mdi-calendar",
        },
      },
      validations:[required()],
      grid:{
        cols:6
      }
    },
    {
      name:"endDateTime",
      editor:"date",
      config: {
        
                attrs: {
                  outlined: true,
                  label: "Конец",
                  appendIcon: "mdi-calendar",
                },
              },
      validations:[required()],
      grid:{
        cols:6
      }
    },
  ]
  
  actions = {
    getDiscounTypes: () => [
      {
        id:1,
        caption:"Процент от обшей суммы"
      },
      {
        id:2,
        caption:"Фиксированная сумма"
      }
    ]
  }

  customHeaders = [
    {
        "text": "ID",
        "value": "id",
        "sortable": true
    },
    {
        "text": "Дата создания",
        "value": "createDate",
        "sortable": true
    },
    {
        "text": "Подпись",
        "value": "caption",
        "sortable": true
    },
    {
        "text": "Код",
        "value": "code",
        "sortable": true
    },
    {
        "text": "Статус",
        "value": "instanceStateId",
        "sortable": false
    }   
  ]

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Промокоды",
        disabled: true,
      },
    ];
  }
}
